import { createFileRoute } from '@tanstack/react-router';
import { PlanoMesPage, lerBuscaCarteira, mesAtual } from '@/components/plano';

export const Route = createFileRoute('/_app/plano/')({
  validateSearch: (bruto: Record<string, unknown>) => {
    const { mes } = lerBuscaCarteira(bruto);
    return mes ? { mes } : {};
  },
  component: PlanoMesRota,
});

function PlanoMesRota() {
  const busca = Route.useSearch();
  return <PlanoMesPage mes={busca.mes ?? mesAtual()} />;
}
